export default {
    HEMORRAGIA_ANTES_DO_PARTO: 574,
    VOMITOS_NAUSEAS_DURANTE_A_GRAVIDEZ: 575,
    SINAIS_SINTOMAS_DA_GRAVIDEZ_OUTROS: 588,
    INFECCOES_QUE_COMPLICAM_A_GRAVIDEZ: 590,
    GRAVIDEZ_NAO_DESEJADA: 596,
    GRAVIDEZ_ECTOPICA: 597,
    TOXEMIA_GRAVIDICA_DHEG: 598,
    GRAVIDEZ_DE_ALTO_RISCO: 601,
    DIABETES_GESTACIONAL: 602,
}